import { UserEnrollmentWithCourse } from '@/models/pegasus-epona/enrollment-course.model';
import { UserEnrollmentsService } from './pegasus-epona/user-enrollments.service';
import {
  UndergradCourses,
  StellateDegreeType,
  DegreeType,
} from '@/models/undergrad/undergrad-courses.model';
import { EnrolledCoursesService } from '@/services/undergrad/mamata/enrolled-courses.service';
import { EnrollmentCourse } from '@/models/mamata/enrollment-course.model';
import { StellateCoursesReaderService } from '@/services/undergrad/stellate/stellate-courses-reader.service';
import { UndergradLive } from '@/models/undergrad/undergrad-live.model';

export class CoursesReaderService {
  public static async getCoursesByIds(): Promise<UndergradCourses[]> {
    const enrolledCourses: EnrollmentCourse[] =
      await EnrolledCoursesService.getUserEnrolledCourses();

    const coursesIds: string[] = enrolledCourses.map((course: EnrollmentCourse) => course.id);

    const coursesData: StellateDegreeType[] = await StellateCoursesReaderService.getCoursesByIdList(
      coursesIds,
    );

    return coursesData.map((courseInfo: StellateDegreeType) => {
      const { faculLiveVideo, ...course } = courseInfo;

      const lives: Record<string, UndergradLive> =
        faculLiveVideo?.reduce((acc: Record<string, UndergradLive>, live: UndergradLive) => {
          acc[live.id] = { ...live };
          return acc;
        }, {}) || {};

      return {
        ...course,
        degreeType: DegreeType.BACHARELADO,
        lives,
        courseEnrollment: enrolledCourses.find(
          (c: EnrollmentCourse) => c.id === course.id,
        ) as EnrollmentCourse,
      };
    });
  }

  public static async getCoursesByUserEnrollments(): Promise<UndergradCourses[]> {
    const { data: enrollments } = await UserEnrollmentsService.getUserEnrollmentsWithCourses();
    enrollments.sort((a, b) => a.id - b.id);

    const courses = enrollments.map((en) => en.course);

    return courses.map((courseInfo) => {
      const courseEnrollment = enrollments.find(
        (enrollment) => enrollment.course.id === courseInfo.id,
      ) as UserEnrollmentWithCourse;

      const lives: Record<string, UndergradLive> = {};

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id, course, ...enrollment } = courseEnrollment;

      return {
        ...courseInfo,
        lives,
        courseEnrollment: { id: course.id, ...enrollment },
      };
    });
  }
}
